// import { Container } from 'inversify';
// import roughModule from './rough/module';

// export default function load(container: Container) {
//   container.load(roughModule);
// }
